import React, { useState, useEffect } from 'react';
import { Box, Fab } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import styled from '@emotion/styled';

const ScrollButton = styled(Fab)(({ theme }) => ({
  position: 'fixed',
  bottom: '30px',
  right: '30px',
  [theme.breakpoints.down('sm')]: {
    bottom: '16px',
    right: '16px',
  },
  zIndex: 99,
  backgroundColor: theme.palette.primary.main,
  color: '#ffffff',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
  opacity: 0,
  visibility: 'hidden',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '&.visible': {
    opacity: 1,
    visibility: 'visible',
  }
}));

function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set the scroll event listener
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <Box>
      <ScrollButton
        size="small"
        aria-label="scroll to top"
        onClick={scrollToTop}
        className={isVisible ? 'visible' : ''}
      >
        <KeyboardArrowUpIcon />
      </ScrollButton>
    </Box>
  );
}

export default ScrollToTop;
